export type Icons16 =
    | "add-16"
    | "animation-loop-16"
    | "animation-pause-16"
    | "animation-play-16"
    | "arrow-down-16"
    | "arrow-left-16"
    | "arrow-left-end-16"
    | "arrow-right-16"
    | "arrow-right-end-16"
    | "arrow-up-16"
    | "chevron-left-16"
    | "chevron-right-16"
    | "delete-16"
    | "grid-16"
    | "layers-16"
    | "lock-16"
    | "missing-16"
    | "search-16"
    | "unlock-16";

export type Icons24 =
    | "animation-first"
    | "animation-last"
    | "animation-next"
    | "animation-pause"
    | "animation-play"
    | "animation-prev"
    | "frames-24"
    | "frames-add-24"
    | "frames-sub-24"
    | "grid-24"
    | "layers-24"
    | "layers-add-24"
    | "layers-merge-24"
    | "layers-remove-24"
    | "layers-sub-24"
    | "lock-24"
    | "missing-24"
    | "symmetry-off-24"
    | "symmetry-on-24"
    | "tool-option-all-layers-off-24"
    | "tool-option-all-layers-on-24"
    | "tool-option-contiguous-off-24"
    | "tool-option-contiguous-on-24"
    | "tool-option-diagonal-off-24"
    | "tool-option-diagonal-on-24"
    | "tool-option-fill-24"
    | "tool-option-no-fill-24"
    | "tool-option-size-24"
    | "tool-option-snap-24"
    | "unlock-24";

export type Icons32 =
    | "box-select"
    | "grid-32"
    | "lasso-select"
    | "missing-32"
    | "shape-circle"
    | "shape-line"
    | "shape-rectangle"
    | "tool-brush"
    | "tool-bucket"
    | "tool-eraser"
    | "tool-eyedrop"
    | "tool-move"
    | "tool-pencil"
    | "wand-select";

export type Icon =
    | Icons16
    | Icons24
    | Icons32;

const sizeMap = {
    "add-16": 16,
    "animation-first": 24,
    "animation-last": 24,
    "animation-loop-16": 16,
    "animation-next": 24,
    "animation-pause-16": 16,
    "animation-pause": 24,
    "animation-play-16": 16,
    "animation-play": 24,
    "animation-prev": 24,
    "arrow-down-16": 16,
    "arrow-left-16": 16,
    "arrow-left-end-16": 16,
    "arrow-right-16": 16,
    "arrow-right-end-16": 16,
    "arrow-up-16": 16,
    "box-select": 32,
    "chevron-left-16": 16,
    "chevron-right-16": 16,
    "delete-16": 16,
    "frames-24": 24,
    "frames-add-24": 24,
    "frames-sub-24": 24,
    "grid-16": 16,
    "grid-24": 24,
    "grid-32": 32,
    "lasso-select": 32,
    "layers-16": 16,
    "layers-24": 24,
    "layers-add-24": 24,
    "layers-merge-24": 24,
    "layers-remove-24": 24,
    "layers-sub-24": 24,
    "lock-16": 16,
    "lock-24": 24,
    "missing-16": 16,
    "missing-24": 24,
    "missing-32": 32,
    "search-16": 16,
    "shape-circle": 32,
    "shape-line": 32,
    "shape-rectangle": 32,
    "symmetry-off-24": 24,
    "symmetry-on-24": 24,
    "tool-brush": 32,
    "tool-bucket": 32,
    "tool-eraser": 32,
    "tool-eyedrop": 32,
    "tool-move": 32,
    "tool-option-all-layers-off-24": 24,
    "tool-option-all-layers-on-24": 24,
    "tool-option-contiguous-off-24": 24,
    "tool-option-contiguous-on-24": 24,
    "tool-option-diagonal-off-24": 24,
    "tool-option-diagonal-on-24": 24,
    "tool-option-fill-24": 24,
    "tool-option-no-fill-24": 24,
    "tool-option-size-24": 24,
    "tool-option-snap-24": 24,
    "tool-pencil": 32,
    "unlock-16": 16,
    "unlock-24": 24,
    "wand-select": 32,
};

export function getIcon(icon: Icon): string {
    const size = sizeMap[icon];
    return `icons-${size}.svg#${icon}`;
}

export function getIconSize(icon: Icon): number {
    return sizeMap[icon];
}